/**
 * Gedeelde placeholder voor afbeeldingen die niet geladen kunnen worden.
 * Het is een inline SVG (data-URI), zodat de placeholder zelf nooit een netwerkverzoek
 * nodig heeft en dus nooit "kapot" kan laden.
 */
const FALLBACK_IMAGE_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160">' +
  '<rect width="160" height="160" rx="16" fill="#eef0f3"/>' +
  '<g fill="none" stroke="#b4bac4" stroke-width="5" stroke-linecap="round" stroke-linejoin="round">' +
  '<rect x="38" y="46" width="84" height="68" rx="8"/>' +
  '<circle cx="60" cy="68" r="8"/>' +
  '<path d="M44 106l22-22 16 16 14-14 20 20"/>' +
  '</g></svg>';

export const FALLBACK_IMAGE_SRC =
  'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(FALLBACK_IMAGE_SVG);

/**
 * Standaard activiteit-/lesafbeeldingen die centraal beschikbaar zijn op de server.
 * Beschikbaar: activiteit_default0.png t/m activiteit_default8.png (9 stuks).
 */
const DEFAULT_ACTIVITEIT_IMAGE_BASE = 'https://www.mylogifit.com/assets/activiteit_default';
const DEFAULT_ACTIVITEIT_IMAGE_COUNT = 9;

/**
 * Kiest deterministisch (stabiel) een standaard activiteit-afbeelding op basis van een seed
 * (bijv. de lesnaam of het id). Zo houdt dezelfde les altijd dezelfde standaardfoto.
 */
export function getDefaultActiviteitImage(seed?: string): string {
  let hash = 0;
  const text = (seed || '').toString();
  for (let i = 0; i < text.length; i++) {
    hash = (hash * 31 + text.charCodeAt(i)) >>> 0;
  }
  const index = hash % DEFAULT_ACTIVITEIT_IMAGE_COUNT;
  return `${DEFAULT_ACTIVITEIT_IMAGE_BASE}${index}.png`;
}
